import React from "react";
import Modal from "newui/components/ui/Modal/Modal";

interface ProcurementCategory {
	methods: string[];
	title: string;
}

const PROCUREMENT_CATEGORIES: ProcurementCategory[] = [
	{
		title: "Traditional (Separated)",
		methods: ["Construct Only", "Cost Plus"],
	},
	{
		title: "Design and Construct (Integrated)",
		methods: [
			"Design & Construct",
			"Design, Construct & Maintain",
			"Engineering, Procure and Construct (EPC)",
			"Novated EPC",
			"Engineering & Procurement and Construction Management (EPCM)",
		],
	},
	{
		title: "Management (Packaged)",
		methods: [
			"Construction Management",
			"Managing Contractor",
			"Design and Manage",
			"Project Management Contractor (PMC)",
		],
	},
	{
		title: "Collaborative (Relational)",
		methods: [
			"Incentivised Target Cost",
			"Project Alliancing",
			"Early Contractor Involvement (ECI)",
			"Contractor Framework (Panel Arrangement)",
			"Alliance Agreement (typically major capital assets - public agent works with private sector)",
			"Collaborative Client Contractor",
			"Delivery Partner",
		],
	},
	{
		title: "Public Private Partnerships (PPP)",
		methods: [
			"Build, Own, Operate and Transfer (BOOT)",
			"Design, Build, Finance and Operate (DBFO)",
			"Design, Build, Finance and Maintain (DBFM)",
			"Design, Build, Operate and Maintain (DBOM)",
			"Design, Construct and Maintain (DCM)",
		],
	},
];

interface ProcurementModelGuidanceModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const ProcurementModelGuidanceModal: React.FC<
	ProcurementModelGuidanceModalProps
> = ({ isOpen, onClose }) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Procurement Model Guidance"
			iconType="info"
			size="xl"
			closeOnOverlayClick
			closeOnEsc
			primaryButton={{
				text: "Close",
				btntype: "secondary",
				onClick: onClose,
			}}
		>
			<div className="text-sm text-gray-600 flex gap-2 flex-col">
				<p>
					When adding new projects to your profile, a procurement model must
					be selected from a pre-defined list for each project. Each category
					comprises of various examples of procurement models listed below.
				</p>
				<p>Please review and select the model relevant to the project.</p>

				<div className="flex flex-col gap-5">
					{PROCUREMENT_CATEGORIES.map((category) => (
						<div key={category.title}>
							<h3 className="mb-1.5 text-sm font-semibold text-blue-600">
								{category.title}
							</h3>
							<ul className="list-none space-y-0.5 pl-4">
								{category.methods.map((method) => (
									<li key={method} className="text-sm text-gray-700">
										{method}
									</li>
								))}
							</ul>
						</div>
					))}
				</div>
			</div>
		</Modal>
	);
};
